import type { AnnouncementCandidate } from "./announcement";
import { selectAnnouncement } from "./announcement";
import type { SiteContext } from "./site";

// The generator emits one tiny candidate list per locale. Lazy glob imports keep
// every other locale — and the full Markdown blog module — out of the root route.
const announcementLoaders = import.meta.glob<{
  announcements: AnnouncementCandidate[];
}>("../generated/announcements.*.ts");

export async function loadAnnouncement(
  site: SiteContext,
  now = new Date(),
): Promise<AnnouncementCandidate | null> {
  const loader = announcementLoaders[`../generated/announcements.${site.locale}.ts`];
  if (!loader) return null;
  const { announcements } = await loader();
  return selectAnnouncement(announcements, site, now);
}
